const MKR = ({ ...props }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0)">
      <path
        d="M10 20.835C15.5228 20.835 20 16.3578 20 10.835C20 5.31214 15.5228 0.834991 10 0.834991C4.47715 0.834991 0 5.31214 0 10.835C0 16.3578 4.47715 20.835 10 20.835Z"
        fill="#1ABC9C"
      />
      <path
        d="M4.41922 8.16776V15.3087H3.1626V5.7363L9.80044 10.541V15.3087H8.54382V11.1533L4.41922 8.16776ZM11.4562 11.1533V15.3087H10.1996V10.541L16.8374 5.7363V15.3087H15.5808V8.16776L11.4562 11.1533Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.834991)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default MKR;
